import { EventEmitter, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { AvailabilityDTO } from '../shared/entity-restriction-checkbox/form-field/entity-restriction-checkbox-form-field.component';

@Injectable({
  providedIn: 'root',
})
export class EntityRestrictionsService {
  private changes: Map<string, AvailabilityDTO> = new Map<string, AvailabilityDTO>();

  public subject: Subject<AvailabilityDTO[]> = new Subject<AvailabilityDTO[]>();

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.clear();
      }
    });
  }

  public remove(change: AvailabilityDTO) {
    this.changes.delete(this.constructId(change));
    this.subject.next(Array.from(this.changes.values()));
  }

  public add(change: AvailabilityDTO) {
    this.changes.set(this.constructId(change), change);
    this.subject.next(Array.from(this.changes.values()));
  }

  public clear() {
    this.changes.clear();
    this.subject.next(Array.from(this.changes.values()));
  }

  asObservable(): Observable<AvailabilityDTO[]> {
    return this.subject.asObservable();
  }

  private constructId(dto: AvailabilityDTO) {
    const id = `${dto.countryId}_${dto.type}_${dto.referenceId}`;
    return id;
  }
}
